import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryHover, lightBlue, white } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	banner: {
		backgroundColor: lightBlue,
		border: `1px solid ${brandPrimary}`,
		borderRadius: 4,
		paddingTop: 12,
		paddingBottom: 12,
		paddingLeft: 16,
		paddingRight: 16,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	buttonContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
	},
	downloadButton: {
		backgroundColor: brandPrimary,
		color: white,
		border: 'none',
		paddingTop: 8,
		paddingBottom: 8,
		paddingLeft: 16,
		paddingRight: 16,
		borderRadius: 4,
		cursor: 'pointer',
		fontSize: 14,
		fontWeight: 500,
		transition: 'background-color 0.2s ease',
		':hover': {
			backgroundColor: brandPrimaryHover,
		},
	},
});
